<template>
  <div class="login-page items-center justify-center">
    <v-card :loading="loading" class="mx-auto item-card pt-12 pb-12">
      <div class="logo mb-5">
        <!-- <v-img src="@/assets/liveStream.png"></v-img> -->
        <v-icon :size="180" color="#333333">mdi-television-classic</v-icon>
      </div>

      <v-form ref="form" v-model="valid" v-on:submit.prevent="validate" class="px-5">
        <v-card-title primary-title class="font-weight-bold px-5">Choose Streaming Server</v-card-title>
        <div class="md-w-100 xs-full-width m-auto">
          <v-row>
              <v-col :cols="11" :lg="11" :md="11" :sm="11">
              <v-select
                v-model="selectedKey"
                :items="streamKeys"
                :rules="ChannelRules"
                placeholder="Please select channel"
                item-text="title"
                item-value="_id"
                outlined
                item-disabled="isUse"
              ></v-select>
            </v-col>
            <v-col :cols="1" :lg="1" :md="1" :sm="1">
              <v-icon small class="refresh-container" @click="getKey">mdi-cached</v-icon>
            </v-col>
          </v-row>
          
        </div>
        <div class="md-w-100 xs-full-width m-auto channelUsed" v-show="isUsingKey">This channel is currently being used. Please select a new channel.</div>
        <br/>
        
        <div class="text-center mt-2 mb-8">
          <v-btn
            :disabled="!valid"
            color="primary"
            class="md-w-100 xs-full-width"
            large
            rounded
            @click="validate"
          >Next</v-btn>
        </div>
      </v-form>
    </v-card>
  </div>
</template>
<script>
import { getLiveStreamKey, setLiveStreamKey } from "@/service/course/live";

export default {
  name: "select-streamkey",
  components: {
    // warnningComponent
  },
  props: {
    openDialog: {
      type: Boolean
    },
    changeStep: {
      type: Function
    },
    courseId: {
      type: String
    },
    liveId: {
      type: String
    }
  },
  data() {
    return {
      valid: true,
      ChannelRules: [v => !!v || "Channel is required"],
      streamKeys: [],
      selectedKey: null,
      isUsingKey: false
    };
  },
  watch:{
    liveId(val){
      if(val){
        this.selectedKey = null
        this.$refs.form.resetValidation();
      }
    }
  },
  async mounted(){
    await this.getKey()
  },
  methods: {
    async getKey(){
      let streamKeysResult = await getLiveStreamKey()
      this.streamKeys = streamKeysResult
    },
    async validate () {
      let result = await setLiveStreamKey({
        idkeystream: this.selectedKey,
        idlivestream: this.liveId,
        idcourse: this.courseId
      })
      if(result.code == 403){
        this.isUsingKey=true
      }
      else{
        this.changeStep(2)
      }
      console.log(result)
      // this.changeStep()
    },
  }
};
</script>
<style scoped>
.logo {
  /* width: 20%; */
  width: 180px;
  margin: 0 auto;
}
.login-page {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../../../assets/bg-live.png');
	background-position:center;
	background-repeat:no-repeat;
	background-size:cover;
}
.item-card {
  /* width: 30%; */
  min-height: 300px;
}

.md-w-100 {
  width: 90%;
}

.m-auto {
  margin: 0 auto !important;
}
.channelUsed{
  color: red;
  font-size: 14px;
  margin-top: -20px!important;
}
.select-container{
  /* width: 307px; */
  display: inline;
}
.select-input{
  width: 307px;
}
.refresh-container{
  margin-top:18px
}

@media only screen and (max-width: 768px) {
  .item-card {
    width: 100%;
    /* min-height: 90%; */
  }
  .login-page {
    height: 100%;
    align-items: unset;
  }
  .xs-full-width {
    width: 90% !important;
  }
}
@media only screen and (min-width: 769px) and (max-width: 1024px) {
  .item-card {
    width: 45%;
    min-height: 560px;
  }
  .or-line {
    width: 94%;
  }
  .login-page {
    height: 100%;
    align-items: center;
  }
  .xs-full-width {
    width: 90% !important;
  }
}
@media only screen and (min-width: 1025px) and (max-width: 1795px) {
  .item-card {
    width: 30%;
  }
}
@media only screen and (min-width: 1796px) {
  .item-card {
    width: 25%;
  }
}
</style>
<style scoped>
.v-application--is-ltr .v-text-field .v-input__append-inner {
    display: inline;
}
</style>